const fr = {
  or: 'OR',
  'auth.login': 'Connectez-vous avec SSO',
  'auth.accept': 'I agree to the',
  'auth.terms': 'Terms of Use',
  'auth.forgotPassword': 'Mot de passe oublié',
  'auth.privacyPolicy': 'Politique de confidentialité',
  'auth.needHelp': 'Need help? Contact',
  'auth.support': 'Support',
  'auth.cookies': 'We use cookies to give you a better experience',
  'auth.terms.toastErrorMessage': 'Please agree to the terms and conditions',
  'auth.redirectErrorToastMessage': 'An error occured during sign-in. Please try again or contact support.',

  'restore.title': 'Réinitialiser mot de passe',
  'restore.updatePassword': 'Mettre à jour le mot de passe',

  'restore.validation.title': 'Your password must contain at least',
  'restore.validation.minOf': 'Min of',
  'restore.validation.characters': 'characters',
  'restore.validation.lowerCase': 'Lower case letter',
  'restore.validation.upperCase': 'Upper case letter',
  'restore.validation.number': 'Numeric character',
  'restore.validation.symbol': 'Special character',

  'resetPassword.expired.title': 'Password has expired',
  'resetPassword.expired.description': 'Set new password to continue use application',

  'confirmSignIn.timer.title': "Please sign in again if you didn't receive the code.",
  'confirmSignIn.rememberDevice': 'Remember this device for 14 days',

  'crashPage.somethingWrong': 'Something went wrong',
  'crashPage.backToLogin': 'Back to login',
  'crashPage.contactAdmin': 'Please contact your system administrator',

  'accessRestrictedByIp.title': 'Your IP address is not authorized for access',
  'accessRestrictedByIp.contactInfo.prefix': "Besoin d'aide ? Contactez votre Administrateur ou le",
  'accessRestrictedByIp.contactInfo.support': 'Support',
  'accessRestrictedByIp.backToLogin': 'Retour à la connexion',

  'ssoFailurePage.title': 'You are not allowed to use application',
  'ssoFailurePage.contactAdmin': 'Please contact your organization administrator',
  'ssoFailurePage.backToLogin': 'Back to login',

  'maintenance.title': 'Service en maintenance',
  'maintenance.subtitle': 'Nous reviendrons bientôt. Réessayez plus tard.',
  'maintenance.subtitle2': 'Thank you for your patience!',

  'forceNewPassword.newPassword.label': 'New password',
  'forceNewPassword.newPassword.placeholder': 'Type new password',

  // fix default translate
  'Enter your Password': 'Saisissez votre mot de passe',
  'Enter your email': 'Saisissez votre adresse email',
  Code: 'code à 6 chiffres',
  'Confirm Password': 'Confirm password',
  'Change Password': 'Set new password',
  'Please confirm your Password': 'Confirm new password',
  'Code *':
    'Please enter the verification code we sent to your email. If you have a confirmed phone number, you may also receive the code via text message.',
  'Confirm SMS Code': 'Code de vérification',
  'Incorrect username or password.': 'Invalid username or password',
  'Invalid code or auth state for the user.':
    "Invalid code submitted. Please click 'Back to Sign' to request a new code",
  'Invalid code provided, please request a code again.':
    "Invalid code submitted. Please click 'Back to Sign' to request a new code",
  'Invalid verification code provided, please try again.': 'Code de vérification est incorrect.',
  'Back to Sign In': 'Back to sign-in',
  'Invalid session for the user, session is expired.': 'Invalid session for the user, the session has expired.',
  'User does not exist.': 'The user does not exist.',
  'Trial is expired.': 'The trial has expired.',
  'Organization is not configured.': 'The organization is not configured.',
  'Company is inactive.': 'The company is inactive.',
  'Your organization has SSO enabled. You cannot login with password':
    'Your organization has Single Sign-On (SSO) enabled. You cannot log in with a password.',
  'Too many invalid credentials attempts. User temporarily locked. Please try again after few seconds.':
    'Too many invalid attempts detected. Your account has been temporarily locked for security reasons. Please try again in few seconds.',
  'Rate exceeded': 'Login failed. Try again later.',
  'Too many requests': 'Login failed. Try again later.',

  'Network error':
    'cognito-idp.eu-west-1.amazonaws.com is blocked, please check your firewall settings or contact network administrator in your organization',
  'Temporary password has expired and must be reset by an administrator.':
    'Your temporary password has expired. Click on "Forgot my password" to send a new one.',
  'Send code': 'Send verification code',
  'Access Token has been revoked': 'An error occured during sign-in. Please try again or contact support.',

  // Change Phone Page
  'phoneVerification.step1.title': 'Verify your phone number',
  'phoneVerification.step1.block1':
    "To protect your account, we need to verify your mobile number. We'll send a verification code by SMS",
  'phoneVerification.step1.block2': 'Enter your phone number for 2 factor authentication:',
  'phoneVerification.step1.phone.placeholder': 'Enter your phone number',
  'phoneVerification.step1.sendButton': 'Send verification code',
  'phoneVerification.step1.verifyButton': 'Verify',
  'phoneVerification.step1.validation.genericError': 'Failed to update phone number',
  'phoneVerification.step1.backButton': 'Back to login screen',
  'phoneVerification.step2.title': 'Enter verification code',
  'phoneVerification.step2.codeSentTo': 'We sent a 6-digit code to',
  'phoneVerification.step2.validation.codeError': 'Wrong or expired code. Please try again',
  'phoneVerification.step2.validation.genericError': 'An error occured while sending the verification code',
  'phoneVerification.step2.changePhone': 'Change your phone number',
  'phoneVerification.skipButton': 'Skip for now',
  'footer.step2.noCodeReceived': "Didn't get a code?",
  'footer.step2.resendCode': 'Resend',
  'footer.step2.changeNumber':
    'By entering your number, you agree to receive a one-time passcode (OTP) via SMS to verify your account',
};

export default fr;
